module.exports = __webpack_public_path__ + "static/img/home1_2.66c0c95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home1_2.jpg
// module id = ACnk
// module chunks = 1